import React, { createContext, useContext, useState, useEffect } from 'react'

interface AfiliadoInitialState {
  isAfiliado: boolean
  setIsAfiliado: (value: boolean) => void
  toggleAfiliado: () => void
  afiliadoSlug: string
  setAfiliadoSlug: (slug: string) => void
}

export const initialState: AfiliadoInitialState = {
  isAfiliado: false,
  setIsAfiliado: () => {},
  toggleAfiliado: () => {},
  afiliadoSlug: '',
  setAfiliadoSlug: () => {},
}

const AfiliadoContext = createContext<AfiliadoInitialState | undefined>(undefined)

// @ts-ignore
export const AfiliadoProvider = ({ children }) => {
  const getInitialState = () => {
    if (typeof window !== 'undefined') {
      const savedState = localStorage.getItem('afiliado-config')
      return savedState ? JSON.parse(savedState) : { isAfiliado: false, afiliadoSlug: '' }
    }
    return { isAfiliado: false, afiliadoSlug: '' }
  }

  const [isAfiliado, setIsAfiliado] = useState(getInitialState().isAfiliado)
  const [afiliadoSlug, setAfiliadoSlug] = useState(getInitialState().afiliadoSlug)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if(isAfiliado)
        localStorage.setItem('afiliado-config', JSON.stringify({ isAfiliado, afiliadoSlug }))
      else
        localStorage.removeItem('afiliado-config')
    }
  }, [isAfiliado, afiliadoSlug])

  const toggleAfiliado = () => {
    setIsAfiliado((prev: boolean) => !prev)
  }

  return (
    <AfiliadoContext.Provider value={{ isAfiliado, setIsAfiliado, toggleAfiliado, afiliadoSlug, setAfiliadoSlug }}>
      {children}
    </AfiliadoContext.Provider>
  )
}

export const useAfiliado = () => {
  const context = useContext(AfiliadoContext)

  if (context === undefined) {
    throw new Error('useAfiliado deve ser usado dentro de um AfiliadoProvider')
  }

  return context
} 